export default __webpack_public_path__ + "static/media/search_iconnew.62ac2757.svg";